import { AssetManagerProjectCardWithTabsTemplate } from "../../../../templates/AssetManagerProjectCardWithTabsTemplate";
import { useProject } from "./useProject";

const Project = (): JSX.Element => {
  const { handleBackClick, tabsList, backButtonText } = useProject();

  return (
    <AssetManagerProjectCardWithTabsTemplate
      activeElement="Projects"
      tabsList={tabsList}
      backButtonText={backButtonText}
      handleBackClick={handleBackClick}
    />
  );
};

export default Project;
